// extracted by mini-css-extract-plugin
export default {"linksWrapper":"style_linksWrapper__v7wiy","linkItemWrapper":"style_linkItemWrapper__5LuNl"};